var _a, _b;
import * as tslib_1 from "tslib";
import { reduxKey } from './constants';
import get from 'lodash/get';
import { setCurrentFolderId, unsetCurrentFolderId, changeCurrentMediaSource, replaceSelect, toggleAppendSelect, deselect, deselectAll, uploadFile, uploadProgress, uploadSuccess, uploadFailure, deselectMulti, setSearchInput, setSearchQuery, unsetSearchQuery, unsetSearchInput, initMediaPopup, setCurrentSubfolderId, unsetCurrentSubfolderId, } from './actions';
var defaultState = {
    mode: null,
    currentFolderId: null,
    currentSubfolderId: null,
    currentMediaSource: null,
    searchInput: '',
    searchQuery: null,
    selectedDeviationIds: [],
    selectionLimit: null,
    fileUploads: [],
    allowGifs: true,
};
var actionHandlers = (_a = {},
    _a[initMediaPopup.toString()] = function (state, action) { return (tslib_1.__assign({}, state, { mode: action.payload.mode, currentFolderId: get(action.payload, 'gallectionFolder.folderId'), currentMediaSource: action.payload.mediaSource, selectionLimit: action.payload.selectionLimit, allowedDeviationTypes: action.payload.allowedDeviationTypes, allowGifs: action.payload.allowGifs, minDeviationWidth: action.payload.minDeviationWidth, minDeviationHeight: action.payload.minDeviationHeight, mediaSourceTypes: action.payload.mediaSourceTypes, withMediaSourceSelector: action.payload.withMediaSourceSelector })); },
    _a[setCurrentFolderId.toString()] = function (state, action) { return (tslib_1.__assign({}, state, { currentFolderId: action.payload })); },
    _a[unsetCurrentFolderId.toString()] = function (state) { return (tslib_1.__assign({}, state, { currentFolderId: null })); },
    _a[setCurrentSubfolderId.toString()] = function (state, action) { return (tslib_1.__assign({}, state, { currentSubfolderId: action.payload })); },
    _a[unsetCurrentSubfolderId.toString()] = function (state, action) { return (tslib_1.__assign({}, state, { currentSubfolderId: null })); },
    _a[changeCurrentMediaSource.toString()] = function (state, action) { return (tslib_1.__assign({}, state, { currentMediaSource: action.payload })); },
    _a[setSearchInput.toString()] = function (state, action) { return (tslib_1.__assign({}, state, { searchInput: action.payload })); },
    _a[unsetSearchInput.toString()] = function (state, action) { return (tslib_1.__assign({}, state, { searchInput: '' })); },
    _a[setSearchQuery.toString()] = function (state, action) { return (tslib_1.__assign({}, state, { searchQuery: action.payload })); },
    _a[unsetSearchQuery.toString()] = function (state, action) { return (tslib_1.__assign({}, state, { searchQuery: null })); },
    _a[replaceSelect.toString()] = function (state, action) { return (tslib_1.__assign({}, state, { selectedDeviationIds: [action.payload] })); },
    _a[toggleAppendSelect.toString()] = function (state, action) {
        var payload = action.payload;
        var selectedDeviationIds = state.selectedDeviationIds;
        var isSelected = selectedDeviationIds.includes(payload);
        var updatedSelectedDeviationIds;
        if (isSelected) {
            updatedSelectedDeviationIds = selectedDeviationIds.filter(function (deviationId) { return deviationId !== payload; });
        }
        else {
            updatedSelectedDeviationIds = selectedDeviationIds.concat([payload]);
        }
        return tslib_1.__assign({}, state, { selectedDeviationIds: updatedSelectedDeviationIds });
    },
    _a[deselect.toString()] = function (state, action) { return (tslib_1.__assign({}, state, { selectedDeviationIds: state.selectedDeviationIds.filter(function (selectedDeviationId) { return selectedDeviationId !== action.payload; }) })); },
    _a[deselectMulti.toString()] = function (state, action) { return (tslib_1.__assign({}, state, { selectedDeviationIds: state.selectedDeviationIds.filter(function (selectedDeviationId) { return !action.payload.includes(selectedDeviationId); }) })); },
    _a[deselectAll.toString()] = function (state) { return (tslib_1.__assign({}, state, { selectedDeviationIds: [] })); },
    _a[uploadFile.toString()] = function (state, _a) {
        var payload = _a.payload;
        return (tslib_1.__assign({}, state, { fileUploads: state.fileUploads.concat([tslib_1.__assign({}, payload)]) }));
    },
    _a[uploadFailure.toString()] = function (state, _a) {
        var payload = _a.payload;
        return (tslib_1.__assign({}, state, { fileUploads: state.fileUploads.slice().map(function (item) {
                return item.fileId === payload.fileId ? payload : item;
            }) }));
    },
    _a[uploadProgress.toString()] = function (state, _a) {
        var payload = _a.payload;
        return (tslib_1.__assign({}, state, { fileUploads: state.fileUploads.slice().map(function (item) {
                return item.fileId === payload.fileId ? payload : item;
            }) }));
    },
    _a[uploadSuccess.toString()] = function (state, _a) {
        var payload = _a.payload;
        return (tslib_1.__assign({}, state, { fileUploads: state.fileUploads.filter(function (item) { return payload.fileId !== item.fileId; }) }));
    },
    _a);
var reducers = (_b = {},
    _b[reduxKey] = function (state, action) {
        if (state === void 0) { state = defaultState; }
        if (!actionHandlers[action.type]) {
            return state;
        }
        return actionHandlers[action.type](state, action) || state;
    },
    _b);
export default reducers;
//# sourceMappingURL=reducers.js.map